import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import { Form, FormGroup, Label, Row, Col, Alert } from "reactstrap";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";

import { postMethod } from "../../../../_services/_postMethod";
import Loader from "../../../modules/loader";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const AddCustomerCategory = (props) => {
  const queryParams = useQuery();
  const id = queryParams.get("id") === "" ? null : queryParams.get("id");
  const { register, handleSubmit } = useForm();
  const [load, setLoad] = useState(false);
  const [loadInser, setLoadInsert] = useState(false);
  const [loadDelete, setLoadDelete] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [branchData, setBranch] = useState({
    category_name: "",
  });
  const [success, setSuccess] = useState(false);
  const [deleteentry, setseleteentry] = useState(false);
  const [deleteentryMsg, setseleteentryMsg] = useState(false);

  const insertData = (values) => {
    setLoadInsert(true);
    values.category_name = branchData.category_name;
    postMethod("api/masters/customer/category/insert", values).then((data) => {
      if (data.data[0].valid) {
        setSuccess(true);
        setTimeout(() => {
          props.history.push("/branch/customer/category");
        }, 2000);
      } else {
        setLoadInsert(false);
      }
    });
  };

  const handleDelete = () => {
    const proceed = window.confirm("Do you Really Wish to Delete this Entry..?!");

    if (proceed) {
      setLoadDelete(true);
      postMethod("api/masters/customer/category/delete", {
        category_id: branchData.category_id,
      }).then((data) => {
        if (data.data[0].valid) {
          setseleteentry(true);
          setseleteentryMsg(data.data[0].msg);
          setTimeout(() => {
            props.history.push("/branch/customer/category");
          }, 2000);
        } else {
          setseleteentry(true);
          setseleteentryMsg(data.error);
          setLoadDelete(false);
          setTimeout(() => {
            setseleteentry(false);
          }, 4000);
        }
      });
    }
  };

  const getcategoryList = () => {
    postMethod("api/masters/customer/category/getCategory", {
      search: branchData.category_name,
    }).then((data) => setCategoryList(data));
  };

  useEffect(() => {
    getcategoryList();
  }, [branchData.category_name]);

  useEffect(() => {
    if (id !== null) {
      setLoad(true);
      const temp = window.atob(id);
      postMethod("api/masters/customer/category/preview", { category_id: temp }).then((data) => {
        setBranch(data.data[0]);
        setLoad(false);
      });
    }
    getcategoryList();
  }, []);

  return (
    <>
      {load ? <Loader /> : null}
      <Form onSubmit={handleSubmit(insertData)} className="category-editor-form">
        <input
          type="hidden"
          name="category_id"
          value={id == null ? "0" : branchData.category_id}
          ref={register}
        />
        <div className="card shadow category-editor-card">
          <div className="category-editor-header">
            <div className="category-editor-title">
              <span className="category-editor-icon">
                <i className="fa fa-tags"></i>
              </span>
              <div>
                <h3>{id ? "Edit Customer Category" : "Add Customer Category"}</h3>
                <p>Create categories to organize customers for filtering and reports.</p>
              </div>
            </div>
          </div>

          <div className="card-body category-editor-body">
            <Row>
              <Col lg={7} md={12}>
                <div className="category-editor-section">
                  <FormGroup className="category-editor-field mb-0">
                    <Label>
                      Category Name <span>*</span>
                    </Label>
                    <Autocomplete
                      id="CategoryName"
                      freeSolo
                      size="small"
                      value={branchData.category_name || ""}
                      options={categoryList.map((option) => option.category_name)}
                      onChange={(event, value) => {
                        setBranch({ ...branchData, category_name: value || "" });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          className="category-editor-autocomplete"
                          placeholder="Enter category name"
                          onChange={(e) =>
                            setBranch({
                              ...branchData,
                              category_name: e.target.value,
                            })
                          }
                          margin="normal"
                          variant="outlined"
                        />
                      )}
                    />
                  </FormGroup>
                </div>
              </Col>
              <Col lg={5} md={12}>
                <div className="category-editor-info">
                  <span>
                    <i className="fa fa-lightbulb-o"></i>
                  </span>
                  <div>
                    <h5>Tip</h5>
                    <p>
                      Keep names short and clear so staff can quickly choose the right
                      customer category.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>

            {success ? <Alert color="success">Saved Successfully</Alert> : null}
            {deleteentry ? <Alert color="danger">{deleteentryMsg}</Alert> : null}
          </div>

          <div className="category-editor-footer">
            <a href="/branch/customer/category" className="btn category-editor-cancel-btn">
              Cancel
            </a>
            {id &&
              (loadDelete ? (
                <button type="button" className="btn btn-danger category-editor-action-btn">
                  Deleting..
                </button>
              ) : (
                <button
                  type="button"
                  onClick={handleDelete}
                  className="btn btn-danger category-editor-action-btn"
                >
                  Delete
                </button>
              ))}

            {loadInser ? (
              <button type="button" className="btn btn-primary category-editor-action-btn">
                Saving..
              </button>
            ) : (
              <button type="submit" className="btn btn-primary category-editor-action-btn">
                Save
              </button>
            )}
          </div>
        </div>
      </Form>
    </>
  );
};

export default AddCustomerCategory;
